// lib
import React from 'react';
import styled from 'styled-components';

// twicapp-ui
import Title1 from '@joinforma/ui/components/Title1';
import Title2 from '@joinforma/ui/components/Title2';
import Body2 from '@joinforma/ui/components/Body2';

// src
import date_helper from 'utils/date-helper';
import { renderCountryName } from 'utils/employee';
import { Address } from './types';

const PrimaryTitleStyled = styled(Title1)``;

const BodyStyled = styled(Body2)`
  color: ${({ theme }) => theme?.colors?.text?.secondary};
`;

const TextStyled = styled(Body2)``;

const ContentStyled = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 32px;
  margin-bottom: 64px;
`;

const BasicInfoRow = styled.div`
  display: flex;
  padding: 15px 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.background.tertiary};
  align-items: center;
`;

const SecondaryTitleStyled = styled(Title2)`
  color: ${({ theme }) => theme?.colors?.text?.secondary};
  display: flex;
  flex-direction: column;
  flex: 0 0 160px;
`;

type BasicInfoSectionProps = {
  first_name: string;
  last_name: string;
  email: string;
  is_company_pretax_enabled: boolean;
  date_of_birth?: string;
  is_primary_residence_present: boolean | number;
  primary_residence: Address;
};

export const BasicInfoSection = ({
  first_name,
  last_name,
  email,
  is_company_pretax_enabled,
  date_of_birth,
  is_primary_residence_present,
  primary_residence,
}: BasicInfoSectionProps) => (
  <>
    <PrimaryTitleStyled>Basic information</PrimaryTitleStyled>
    <BodyStyled>
      This information is taken from your company's HR admin system. To make
      changes, contact your HR representative.
    </BodyStyled>
    <ContentStyled>
      <BasicInfoRow>
        <SecondaryTitleStyled>Legal name</SecondaryTitleStyled>
        <TextStyled>
          {first_name} {last_name}
        </TextStyled>
      </BasicInfoRow>
      <BasicInfoRow>
        <SecondaryTitleStyled>Work email</SecondaryTitleStyled>
        <TextStyled>{email}</TextStyled>
      </BasicInfoRow>
      {is_company_pretax_enabled && date_of_birth && (
        <BasicInfoRow>
          <SecondaryTitleStyled>Date of birth</SecondaryTitleStyled>
          <TextStyled>
            {date_helper.utc(date_of_birth).format('MMM DD, YYYY')}
          </TextStyled>
        </BasicInfoRow>
      )}
      {is_company_pretax_enabled && is_primary_residence_present ? (
        <BasicInfoRow>
          <SecondaryTitleStyled>Primary residence</SecondaryTitleStyled>
          <TextStyled>
            {primary_residence?.street}
            <br />
            {primary_residence?.street_ext}
            <br />
            {`${primary_residence?.locality}, ${primary_residence?.state} ${
              primary_residence?.zip
            }, ${renderCountryName(primary_residence?.country)}`}
          </TextStyled>
        </BasicInfoRow>
      ) : (
        ''
      )}
    </ContentStyled>
  </>
);
